import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_INVOICE: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 150,
    type: 'action',
    actions: [
      {
        name: 'print',
        iconName: 'print',
      },
      {
        name: 'email',
        iconName: 'email',
      },
    ],
    alignClass: 'text-start',
  },
  { dataKey: 'id', label: 'ID', width: 100, type: 'number' },
  { dataKey: 'invNo', label: 'Invoice Number', width: 150, type: 'number' },
  {
    dataKey: 'transactionId',
    label: 'Transaction ID',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'receiptId',
    label: 'Receipt ID',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'invDate',
    label: 'Invoice Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'paymentMethod',
    label: 'Payment Method',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'cardType',
    label: 'Card Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'status',
    label: 'Invoices Status',
    width: 150,
    type: 'status'
  },
];

export const INVOICE_STATUS_DROPDOWN: any[] = [
  {
    value: 1,
    name: 'Paid',
  },
  {
    value: 2,
    name: 'Unpaid',
  },
  {
    value: 3,
    name: 'Declined',
  },
];

// ========================INVOICE==============
export const TABLE_CONFIG_COLUMNS_INVOICE_LIST: DyTableColumn[] = [
  {
    dataKey: 'invoiceNumber',
    label: 'Invoice Number',
    width: 100,
    type: 'text',
  },
  {
    dataKey: 'planSubscription',
    label: 'Plan/Subscription',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'period',
    label: 'Period',
    width: 100,
    type: 'text',
  },
  {
    dataKey: 'netTotal',
    label: 'Amount',
    width: 50,
    type: 'currency',
  },
  {
    dataKey: 'invoiceDate',
    label: 'Invoice Date',
    width: 100,
    type: 'text',
  },
  {
    dataKey: 'dueDate',
    label: 'Due Date',
    width: 100,
    type: 'text',
  },
  {
    dataKey: 'status',
    label: 'Status',
    width: 50,
    type: 'status',
    tooltipDescriptionType: 'status-invoice'
  },
  {
    dataKey: 'pay',
    label: 'Pay',
    width: 80,
    type: 'clickableLink',
  },
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 100,
    type: 'action',
    actions: [
      {
        name: 'view',
        iconName: 'view',
      },
      {
        name: 'download',
        iconName: 'download',
      },
    ]
  },
];
